import Definition from "./Definition";

const TaxaList = (props) => {
    const taxa = props.taxa.map((taxon,index,taxa) => {
        let taxaSubHeading = <></>
        let collection = <></>
        if(props.collection === null || props.collection.description !== taxon.collection_name)
        {
            collection = <Definition dt={'Collection'} dd={taxon.collection_name} />
        }
        let taxaNameDefinition = <Definition dt={'Taxon Name'} dd={taxon.name} />
        if(taxa.length > 1){
            taxaSubHeading = <h5>{taxon.name}</h5>
            taxaNameDefinition = <></>
        }
        return (
            <div key={taxon.id}>
                {taxaSubHeading}
                <dl className={'row'}>
                    {collection}
                    {taxaNameDefinition}
                    <Definition dt={'Common Name'} dd={taxon.common_name} />
                    <Definition dt={'Order'} dd={taxon.order} />
                    <Definition dt={'Family'} dd={taxon.family} />
                    <Definition dt={'Genus'} dd={taxon.genus} />
                    <Definition dt={'Species'} dd={taxon.species} />
                    <Definition dt={'Subspecies'} dd={taxon.subspecies} />
                    <Definition dt={'Super Species'} dd={taxon.super_species} />
                    <Definition dt={'Super Genus'} dd={taxon.super_genus} />
                </dl>
            </div>
        )
    })
    if(taxa.length > 1) {
        return (
            <>
                <h4>Taxa Information</h4>
                {taxa}
            </>
        )
    }
    return (
        <>
            <h4>Taxon Information</h4>
            {taxa}
        </>
    )
}

export default TaxaList
